/**
 * Strategic plan section — reveal only.
 *
 * @package HelloElementorChild
 */

import { initCamstReveal, teardownCamstReveal } from './camst-reveal.js';

export function initCamstStrategicPlan(scope) {
  var roots = [];

  if (!scope) {
    roots = Array.prototype.slice.call(document.querySelectorAll('[data-camst-strategic-plan]'));
  } else if (scope.matches && scope.matches('[data-camst-strategic-plan]')) {
    roots = [scope];
  } else {
    roots = Array.prototype.slice.call(scope.querySelectorAll('[data-camst-strategic-plan]'));
  }

  roots.forEach(function (root) {
    if (root.dataset.camstStrategicPlanInit === '1') {
      return;
    }

    root.dataset.camstStrategicPlanInit = '1';
    initCamstReveal(root);
  });
}

export function teardownCamstStrategicPlan(scope) {
  if (!scope) {
    return;
  }

  var roots = scope.matches && scope.matches('[data-camst-strategic-plan]')
    ? [scope]
    : Array.prototype.slice.call(scope.querySelectorAll('[data-camst-strategic-plan]'));

  roots.forEach(function (root) {
    teardownCamstReveal(root);
    delete root.dataset.camstStrategicPlanInit;
  });
}
